import axios from 'axios'
import Vue from 'vue'

const http = axios.create({
    // baseURL: 'http://www.xx.com/admin/api'
    baseURL: 'https://stock-dashboard.data-mc.cn' // 连接生产环境，发布时应注释掉，baseURL应为''即访问本机
    // baseURL: ''
})

http.interceptors.request.use(config => {
    return config;
}, error => {
    return Promise.reject(error);
});

http.interceptors.response.use(res => {
    return res  //正常返回
}, err => { //有错误时，处理
    if (err.response.data.message) {//有错误信息，就提示
        Vue.prototype.$message({
            type: 'error',
            message: err.response.data.message
        })
    }
    return Promise.reject(err)
})

export default http